import type {
  ToothBasisSliceOptionsBySeries,
  ToothSliceThickness,
} from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import type { ToothSliceOptionsBySeries } from '../config';
import { TOOTH_BASIS_SERIES_ORDER } from '../config';

export const toEngineThickness = (
  thicknessMm: number,
): ToothSliceThickness => ({
  kind: 'slab',
  thicknessMm,
});

export const toEngineSliceOptions = (
  options: ToothSliceOptionsBySeries,
): ToothBasisSliceOptionsBySeries =>
  TOOTH_BASIS_SERIES_ORDER.reduce<ToothBasisSliceOptionsBySeries>(
    (engineOptions, seriesName) => ({
      ...engineOptions,
      [seriesName]: {
        sliceStepMm: options[seriesName].sliceStepMm,
        thickness: toEngineThickness(options[seriesName].thicknessMm),
      },
    }),
    {},
  );
